import { CartItem } from '@displate/styleguide/dist/hydra/types/Cart/Cart.type';

import { CartPreviewItem } from 'generatedBfw/static';

export const mapCartItems = (items: Array<CartPreviewItem> | undefined): CartItem[] | undefined => {
  if (!items) {
    return undefined;
  }
  return items.map((x) => {
    return {
      itemCollectionId: x.itemCollectionId,
      imageUrl: x.imageUrl,
      price: x.price,
      priceDiscounted: x.priceDiscounted ?? null,
      format: x.format,
      quantity: x.quantity,
      frame: x.frame,
      gloss: x.isGloss,
      isMagnet: x.isMagnet,
    };
  });
};
